import { Link } from "@tanstack/react-router";
import { ACCENTS, useControls } from "../lib/controls";

const NAV_ITEMS = [
  { addr: "0x00", to: "/", label: "home" },
  { addr: "0x01", to: "/about", label: "about" },
  { addr: "0x02", to: "/projects", label: "projects" },
  { addr: "0x03", to: "/experience", label: "experience" },
  { addr: "0x04", to: "/blog", label: "blog" },
] as const;

// The persistent header-equivalent: address-labeled nav + the controls
// cluster (theme/accent/verbosity/sound). Present on every route per the
// design-reference README.
export function Rail() {
  const { theme, accent, verbose, soundOn, toggleTheme, setAccent, toggleVerbose, toggleSound, playSound } =
    useControls();

  return (
    <div className="rail">
      {NAV_ITEMS.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          activeProps={{ className: "on" }}
          onClick={() => playSound("key")}
          title={item.label}
        >
          {item.addr}
        </Link>
      ))}
      <div className="controls">
        <div className="swatch-row">
          {ACCENTS.map((a) => (
            <button
              key={a.name}
              type="button"
              className={`swatch${a.name === accent.name ? " active" : ""}`}
              style={{ background: a.color }}
              title={a.name}
              onClick={() => setAccent(a)}
            />
          ))}
        </div>
        <button type="button" className={verbose ? "active" : ""} onClick={toggleVerbose}>
          {verbose ? "-v on" : "-v off"}
        </button>
        <button type="button" onClick={toggleSound}>
          {soundOn ? "sound: on" : "sound: off"}
        </button>
        <button type="button" onClick={toggleTheme}>
          {theme === "dark" ? "mode: dark" : "mode: light"}
        </button>
      </div>
    </div>
  );
}
